import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
	 theme: {
	    themes: {
	      light: {
	        primary: '#1A1EB8',
	        secondary: '#CF1E06',
	        accent: '#f9780d',
	        error: '#ED7779',
	      },
	    },
	  },
});
